import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Tabs } from '../../../../components/Tabs';
import { DeliveredTasksPanel } from './DeliveredTasksPanel';
import { BugsPanel } from './BugsPanel';
import { DeliveriesPanel } from './DeliveriesPanel';
import { NEXUS_TABS, parseNexusTab } from './deliveredTaskHelpers';

export function GoogleNexusTool({ mobileNavTrigger }: { mobileNavTrigger?: React.ReactNode }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = parseNexusTab(searchParams.get('tab'));

  const selectTab = (id: string) => {
    setSearchParams(() => {
      // Each tab owns its own query parameters; Delivered Tasks is the default.
      const next = new URLSearchParams();
      if (id === 'deliveries' || id === 'bugs') next.set('tab', id);
      return next;
    }, { replace: true });
  };

  return (
    <section className="min-w-0 max-w-7xl">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">Google Nexus</h1>
          <p className="mt-1 max-w-3xl text-sm text-gray-500">
            Tasks delivered to Google Nexus and the validation progress of each delivery.
          </p>
        </div>
        {mobileNavTrigger}
      </div>

      <div className="mt-4">
        <Tabs tabs={[...NEXUS_TABS]} activeId={tab} onChange={selectTab} />
      </div>

      {tab === 'deliveries' ? <DeliveriesPanel /> : tab === 'bugs' ? <BugsPanel /> : <DeliveredTasksPanel />}
    </section>
  );
}
